import { createStore } from 'stimulus-store';

export const manufacturerStore = createStore({
    name: 'manufacturerStore',
    type: Object,
    initialValue: {}
});